import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

/**
 * Service is intended to process HTTP requests errors
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}

  /**
   * Intercept an outgoing `HttpRequest` and optionally transform it or the response.
   * @param request http request
   * @param next http handler
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        error: (error) => {
          if (error instanceof HttpErrorResponse && error.status !== 401) {
            console.error(
              `Backend returned code ${error.status}, body was: ${error.error}`
            );
          }
        },
      })
    );
  }
}
